export default function () {
  const forms = document.getElementsByClassName("disabled-on-submit")
  for (let i = 0; i < forms.length; i++) {
    const form = forms[i]
    form.addEventListener("submit", () => {
      const buttons = form.querySelectorAll("[type='submit']")
      for (let j = 0; j < buttons.length; j++) {
        let button = buttons[j]

        if (button.querySelector(".type-button")) {
          button.innerHTML = `<span class="with-icon gap-2.5 type-button"> Saving... </span>`
        } else {
          button.innerText = `Saving...`
        }

        button.disabled = true
      }
    })
  }
}
